import React, { useState, useEffect, useRef } from "react";
import classes from "./styles.module.scss";
import {languages, text} from "./constants.js"
import useToast from "../../Hooks/useToast.js";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { getSummary } from "../../Api/services/summarize.js";
import { fetchEventSource } from "@microsoft/fetch-event-source";

export const SpeechToTextLive = () => {
    const [timer, setTimer] = useState(null);
    const [recording, setRecording] = useState(false)
    const [speechLanguage, setSpeechLanguage] = useState("fa-IR")
    const [listening, setListening] = useState(false)
    const [summary, setSummary] = useState('')
    const [recognitionText, setRecognitionText] = useState('')
    const [previousTranscript, setPreviousTranscript] = useState('')

    const {
        transcript,
        interimTranscript,
        finalTranscript,
        resetTranscript,
        } = useSpeechRecognition();

    useEffect(() => {
        console.log(transcript.split(" ").length, previousTranscript.split(" ").length -3)
        if(transcript.split(" ").length < previousTranscript.split(" ").length - 2 || 
           transcript.split(" ").length > previousTranscript.split(" ").length + 2 ){
            console.log("error occured")
            setRecognitionText(prev => prev + ' ' + previousTranscript)
            setPreviousTranscript("")
            resetTranscript()
            resetRecognition()

        }else 
            setPreviousTranscript(transcript)
        if(listening){
            if (timer) {
                clearTimeout(timer);
                setTimer(null);
            }
            setTimer(
                setTimeout(() => {
                    resetRecognition()
                }, 4000)
            );
        }
    }, [interimTranscript, finalTranscript]);

    const resetRecognition = () => {
        SpeechRecognition.stopListening()                    
        setTimeout(() => {
            SpeechRecognition.startListening({
                continuous: true,
                language: speechLanguage,
            });
        }, 500);
    }

    const handleIconClick = () => {
        if(recording){
            SpeechRecognition.stopListening()
            setRecognitionText(prev => prev + ' ' +transcript)
            setPreviousTranscript("")
            resetTranscript()
            setListening(false)

        }else{
            SpeechRecognition.startListening({
                continuous: true,
                language: speechLanguage,
            });
            setListening(true)
        }
        
        setRecording(prev=>!prev)
    }

    async function handleSummarize() {
        setSummary('')

        await fetchEventSource(`https://lab.teamyab.com/api/gpt/summarize?text=${recognitionText}`, {
            method: "GET",
            headers: {},
            openWhenHidden: true,
            onmessage(event) {
                let data2 = JSON.parse(event.data);
                setSummary(prev => prev + data2) 
            },

            onerror(error) {            
                throw error;
            }
            
        }).catch(err=>console.log(err));
    }
    
    return (
        <div className={classes.container}>
            {!SpeechRecognition.browserSupportsSpeechRecognition() && text.noSupport}
            {SpeechRecognition.browserSupportsSpeechRecognition() &&
            <>
                <h1>{text.pageTitle}</h1>
                <div className={classes.sttContainer}>
                    <div className={classes.recordContainer}>
                        <div className={recording ? classes.recordIconEnable : classes.recordIconDisable} onClick={handleIconClick} />
                        {recording ? text.recordingMsg : text.stoppedMsg}
                        <select disabled={listening} className={classes.languageInput} onChange={(event)=>setSpeechLanguage(event.target.value)} >
                            {languages.map(lan => 
                                <option key={lan.language} value={lan.language}>{lan.country}</option>
                            )}
                        </select>
                    </div>
                    <div className={classes.leftBoxContainer}>
                        <div className={classes.textContainer}>
                            {(`${recognitionText} ${transcript}`) || text.textPlaceholder}
                        </div>
                        <div className={classes.buttonsContainer}>
                            <button className={classes.button} onClick={handleSummarize} >summarize</button>
                            <button className={classes.button} onClick={resetTranscript}>clear</button>
                        </div>

                    </div>
                </div>
                {summary && 
                <div className={classes.summaryContainer}>
                    {summary}
                </div>
                }
            </>
            }
        </div>
    );
}
